const stableId = (record: any): string | null => {
  const id = record?.visitor_pass_id ?? record?.public_id ?? record?.uuid ?? record?.id;
  return id == null || id === '' ? null : String(id);
};

const legacyLink = (record: any): string | null => {
  const id = record?.visitor_pass_id ?? record?.pass_id ?? record?.public_id;
  return id == null || id === '' ? null : String(id);
};

/** Canonical pass rows win over their legacy guest_pin projection. */
export function mergeVisitorPassRecords(canonical: any[], legacy: any[]): any[] {
  const result = new Map<string, any>();
  canonical.forEach((record, index) => result.set(stableId(record) ?? `canonical:${index}`, { ...record, _source: 'visitor_pass' }));
  legacy.forEach((record, index) => {
    const linked = legacyLink(record);
    if (linked && result.has(linked)) return;
    const key = stableId(record) ?? `legacy:${index}`;
    if (!result.has(key)) result.set(key, record);
  });
  return Array.from(result.values());
}
